import { useCallback, useRef } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {
    HAIR_COLOR_OPTIONS,
    HAIR_COLOR_NO_CHANGE_KEY,
} from '../../../../config/dataConfig/FJHairstyleChangerDataConfig';
import FJImage from '../../../../common/components/FJImage/FJImage';
import FJToolTip from '../../../../common/components/FJToolTip/FJToolTip';
import FJHoverBoardGradation from '../../../../common/components/FJHoverBoard/FJHoverBoardGradation';
import NoChange from '../../../../assets/svg/no-change.svg?react';
import ArrowIcon from '../../../../assets/svg/button-right-2.svg?react';
import FJLocalStore from '../../../../store/FJLocalStore';
import FJConfig from '../../../../config/appConfig/FJAIHairstyleChangerConfig';
import FJDropdownNew from '../../../../common/components/FJDropDown/FJDropdownNew';

import styles from './FJHairColorPicker.module.less';

function FJHairColorPicker({ onSelect, value }) {
    const hairColorRef = useRef(null);

    const _renderOverlay = useCallback(
        config => (
            <div className={styles.color_box} ref={config.ref}>
                {HAIR_COLOR_OPTIONS.map(item =>
                    item.key === HAIR_COLOR_NO_CHANGE_KEY ? (
                        <FJHoverBoardGradation
                            key={item.key}
                            active={value.key === item.key}
                            borderRadius={6}
                            isShowInBorder
                        >
                            <FJToolTip
                                title={FJLocalStore._(item.key === HAIR_COLOR_NO_CHANGE_KEY ? 'original' : value.key)}
                            >
                                <div
                                    className={classNames(styles.color_item, styles.no_change_icon)}
                                    onClick={() => {
                                        onSelect(item);
                                        hairColorRef.current?.hide();
                                    }}
                                >
                                    <NoChange />
                                </div>
                            </FJToolTip>
                        </FJHoverBoardGradation>
                    ) : (
                        <FJHoverBoardGradation
                            key={item.key}
                            active={value.key === item.key}
                            borderRadius={6}
                            isShowInBorder
                        >
                            <FJToolTip title={FJLocalStore._(item.key)}>
                                <div
                                    className={styles.color_item}
                                    onClick={() => {
                                        onSelect(item);
                                        hairColorRef.current?.hide();
                                    }}
                                >
                                    <FJImage
                                        imgSrc={FJConfig.hairColorPath + item.filename + `?v=${FJConfig.version}`}
                                        boxClassName={styles.img_box}
                                        imgClassName={styles.img}
                                    />
                                </div>
                            </FJToolTip>
                        </FJHoverBoardGradation>
                    ),
                )}
            </div>
        ),
        [onSelect, value.key],
    );

    const _renderTrigger = useCallback(
        config => (
            <div className={styles.trigger} ref={config.ref}>
                <div
                    className={styles.trigger_btn}
                    onClick={() => {
                        config.onClick();
                    }}
                >
                    {value.key === HAIR_COLOR_NO_CHANGE_KEY ? null : (
                        <div className={styles.img_box}>
                            <FJImage
                                imgSrc={FJConfig.hairColorPath + value.filename + `?v=${FJConfig.version}`}
                                loading='lazy'
                            />
                        </div>
                    )}
                    <div className={styles.name}>
                        {FJLocalStore._(value.key === HAIR_COLOR_NO_CHANGE_KEY ? 'original' : value.key)}
                    </div>
                    <ArrowIcon className={styles.arrow_icon} />
                </div>
            </div>
        ),
        [value.filename, value.key],
    );

    return (
        <div className={styles.container}>
            <p className={styles.title}>{FJLocalStore._('color')}</p>
            <FJDropdownNew
                placement='rightTop'
                trigger='click'
                offsetLeft={22}
                offsetTop={62}
                ref={hairColorRef}
                renderOverlay={_renderOverlay}
                renderTrigger={_renderTrigger}
                isTopLayer
            />
        </div>
    );
}

FJHairColorPicker.propTypes = {
    onSelect: PropTypes.func,
    value: PropTypes.shape({
        key: PropTypes.string,
        value: PropTypes.string,
        filename: PropTypes.string,
    }),
};

export default FJHairColorPicker;
